module.exports = "/images/ny-street-2.jpg";